import EvaluationModulePage from './_EvaluationModulePage'

const FinancialsPage = () => (
	<EvaluationModulePage
		moduleName="Financials"
		moduleDescription="Pick an evaluation to model acquisition, operating, and ROI cash flows."
		workspacePhase="MYD-186 (B3)"
		workspaceHint="Per-site selector with Acquisition / Operating / ROI tabs and live IRR / NPV / payback calculation."
	/>
)

export default FinancialsPage
